module.exports = __webpack_public_path__ + "templates/cart-shipping_billing_address.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cart/templates/cart-shipping_billing_address.html
// module id = KlS/
// module chunks = 1